import axios from "axios";

// In development, use localhost. In production, use relative path
const isDevelopment = process.env.NODE_ENV === "development";
const API_URL = isDevelopment ? "http://localhost:3002/api" : "/api";

// Public endpoint - no token needed, only returns published projects
export const getProjects = async (token = null) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    // If token is provided, add it to headers (for admin access)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    const response = await axios.get(`${API_URL}/projects`, config);
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error fetching projects:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

// Admin-only functions below - require authentication
export const createProject = async (projectData, token) => {
  try {
    const response = await axios.post(`${API_URL}/projects`, projectData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error creating project:",
        error.response?.data || error.message
      );
    }
    throw error.response?.data || new Error("Failed to create project");
  }
};

export const updateProject = async (projectId, projectData, token) => {
  try {
    if (process.env.NODE_ENV === "development") {
      console.log(
        `PUT Request to /api/projects/${projectId} with data:`,
        projectData
      );
    }
    const response = await axios.put(
      `${API_URL}/projects/${projectId}`,
      projectData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error updating project:",
        error.response?.data || error.message
      );
    }
    throw error.response?.data || error;
  }
};

export const deleteProject = async (id, token) => {
  try {
    const response = await axios.delete(`${API_URL}/projects/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error deleting project:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};

export const reorderProjects = async (projectOrders, token) => {
  try {
    const response = await axios.put(
      `${API_URL}/projects/reorder`,
      { projectOrders },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.error(
        "Error reordering projects:",
        error.response?.data || error.message
      );
    }
    throw error;
  }
};
